/**
 * Shared call constants — safe to import from any feature.
 * Do NOT import from @/features/calls/constants directly.
 */
export const CALL_TYPE = {
   AUDIO: 'AUDIO',
   VIDEO: 'VIDEO',
};

export const CALL_MODES = {
   ONETOONE: 'ONE-TO-ONE',
   ONETOMANY: 'ONE-TO-MANY',
   MEET: 'MEET',
};
